import React from "react";
import { useEffect } from "react";
import Footer from "../components/footer";
import NavbarHome from "../components/navbar-home";
import ShopContent from "../pages/Sheets/shop-content";
import ShopJumbotron from "../pages/Sheets/shop-jumbotron";

export default function PageShop() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <NavbarHome />
      <ShopJumbotron />
      <ShopContent />
      <Footer />
    </>
  );
}
